import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table'
import { catchError } from '../../helpers/catch-error'
import { NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

const Incomplete = () => {
  const navigate = useNavigate();

  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => <a 
          className={row.is_updated == 1 ? "fw-bold text-shadow text-danger" : ""}
          href={"/admin/work-order/" + row.work_order_id} >{row.patient_last_name + " " + row.patient_first_name}</a>,
        id: "lastName",
        cell: info => info.getValue(),
        header: () => "Patient",
        footer: props => props.column.id
      },
      {
        accessorKey: "client_company_name",
        header: "Client",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>
          <a onClick={() => cancelWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link m-0 p-0 me-2">Cancel</a>              
          <a onClick={() => deleteWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link m-0 p-0 me-2">Delete</a>              
      
        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
      }

    ],
    []
  )


  const [data, setData] = React.useState(null);

  const getWorkOrders = async () => {

    await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-incomplete-work-orders", {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);

        } else {


          Swal.fire({ icon: "error", title: "Incomplete Work Order Failed to Load", text: response?.data?.message });

        }

      })
      .catch(function (error) {

        catchError(error,navigate)

      });

  }



const cancelWorkOrder = async (work_order_id) => {

  await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/cancel-work-order", {
    work_order_id: work_order_id
  }, {
    withCredentials: true
  })
    .then(function (response) {

      if (response?.data?.status) {

        Swal.fire({ icon: "success", title: "Record closed successfully" });
        getWorkOrders();

      } else {

        Swal.fire({ icon: "error", title: "Unable to close work order" });

      }

    })
    .catch(function (error) {

      catchError(error,navigate)

    });


}




const deleteWorkOrder = async (work_order_id) => {



  Swal.fire({
    title: "Are you sure, you want to delete this?",
    text: "You won't be able to revert this action!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
}).then((result) => {
    if (result.isConfirmed) {

        
  axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/delete-work-order", {
    work_order_id: work_order_id
  }, {
    withCredentials: true
  })
    .then(function (response) {

      if (response?.data?.status) {

        Swal.fire({ icon: "success", title: "Record deleted successfully" });
        getWorkOrders();

      } else {

        Swal.fire({ icon: "error", title: "Unable to delete work order" });

      }

    })
    .catch(function (error) {

      catchError(error,navigate)

    });



    }
});

}


  useEffect(() => {

    getWorkOrders();

  }, []);

  return (
    <>


   
<div className="row py-2 start-0 bg-light">

<div className="col-md-12 col-sm-12 mx-auto text-center">
  <div className="container-fluid z-2  ">

    <span className="btn btn-warning rounded-0 me-1">
      <NavLink className="nav-link" smooth to="/admin/work-orders-active">
        ACTIVE
      </NavLink>
    </span>
      { localStorage.getItem('@is_super_admin') == 1 &&
           <>                            
               
     <span className="btn btn-warning rounded-0 me-1">
                          <NavLink className="nav-link" smooth to="/admin/work-orders-invoice-needed">
                            INVOICE NEEDED
                          </NavLink>
                        </span>
    <span className="btn btn-warning rounded-0  me-1 ">
      <NavLink className="nav-link" smooth to="/admin/work-orders-records-obtained">
        RECORDS OBTAINED
      </NavLink>
    </span>
    <span className="btn btn-warning rounded-0  me-1 ">
      <NavLink className="nav-link" smooth to="/admin/work-orders-closed">
        CLOSED
      </NavLink>
    </span>

    <span className="btn btn-warning rounded-0  me-1 ">
      <NavLink className="nav-link" smooth to="/admin/work-orders-archived">
        ARCHIVED
      </NavLink>
    </span>
</>

      }
    <span className="btn btn-warning rounded-0  me-1 ">
      <NavLink className="nav-link" smooth to="/admin/work-orders-canceled">
        CANCELED
      </NavLink>
    </span>

    <span className="btn btn-success rounded-0  me-1 ">
      <NavLink className="nav-link" smooth to="/admin/work-orders-incomplete">
        INCOMPLETE
      </NavLink>
    </span>

    <span className="btn btn-warning rounded-0  ">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-missing">
                    MISSING
                  </NavLink>
                </span>
  </div>
</div>
</div>


<div className="row py-4 start-0  mx-auto ">

<div className="col-md-6 col-sm-12  ">
  <h3 className="text-dark my-0">INCOMPLETE WORK ORDERS</h3>
</div>

<div className="col-md-6 col-sm-12 ps-3 text-end">

  <span className="btn btn-primary rounded-0 me-1">
    <NavLink className="nav-link" smooth to="/admin/work-orders-new">
      NEW
    </NavLink>
  </span>
  <span className="btn btn-danger rounded-0  me-1 ">
    <NavLink className="nav-link" smooth to="/admin/work-orders-search">
      SEARCH
    </NavLink>
  </span>

</div>

</div>


          



      {data &&

     
<div className="card border-4 border-dark rounded-1 card-success mb-4" >

<div className="card-body p-0" >
            <CustomTable columns={columns} data={data} />

          </div>
        </div>


      }
    </>

  );
};

export default Incomplete;